module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Pizza-49b3f97059bc8b98e58aae7f2a7e177f.svg";